import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAK00SyH3JhJegPzERYQVCa9N6caEyqfeQ",
    authDomain: "whatsapp-clone-2349b.firebaseapp.com",
    databaseURL: "https://whatsapp-clone-2349b.firebaseio.com",
    projectId: "whatsapp-clone-2349b",
    storageBucket: "whatsapp-clone-2349b.appspot.com",
    messagingSenderId: "384227016164",
    appId: "1:384227016164:web:d48c1956eba09db3ffdbf1",
    measurementId: "G-VTM5XTX3WE"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export {auth, provider};
export default db;

export const createRoom = () => {
    const roomName = prompt('Please enter name for new room');
    if (roomName) {
        db.collection('rooms').add({
            name: roomName
        });
    }
};